import { PermissionStatus, } from '@office-start/metaos-hub-sdk';
import { logFeature } from '@office-start/telemetry-service';
import { useCallback, useRef, useState } from 'react';
import { logAppHostUserAction } from '../utilities/logAppHostUserAction';
/** This function returns callbacks for opening and closing the permission request (consent) dialog.
 * @param appId Used for telemetry
 */
export function useConsentRequest(appId) {
    const [permissionRequested, setPermissionRequested] = useState();
    const permissionResolveRef = useRef();
    const showConsentDialogCallback = useCallback((permissionRequested) => {
        setPermissionRequested(permissionRequested);
        logFeature({
            featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
            eventName: "MOS_Permission_Request_Dialog_Open" /* KnownFeatureInstrumentationEvents.MOSPermissionRequestDialogOpen */,
            params: {
                AppId: appId,
                AppCapabilities: 'OpenAppPermissionsRequestDialog',
                DebugInfo: 'showConsentDialogCallback',
                Service: 'AppHostDevicePermissionsService',
            },
            area: 'MOSAppHost',
            subArea: 'MOSPermissionRequestDialog',
        });
        return new Promise((resolve) => {
            permissionResolveRef.current = resolve;
        });
    }, [appId]);
    const closeConsentDialogCallback = useCallback((userResponse) => {
        var _a;
        setPermissionRequested(undefined);
        (_a = permissionResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(permissionResolveRef, userResponse);
        permissionResolveRef.current = undefined;
        let telemetryActionResult;
        switch (userResponse) {
            case PermissionStatus.Consented:
                telemetryActionResult = 'Allow';
                break;
            case PermissionStatus.Revoked:
                telemetryActionResult = 'Deny';
                break;
            case PermissionStatus.NeverAsked:
                // Shouldn't be able to get here, but just in case
                telemetryActionResult = 'Cancel';
                break;
        }
        logAppHostUserAction(telemetryActionResult, 'MOSAppHost', "MOS_Permission_Request_Dialog_Choice" /* KnownFeatureInstrumentationEvents.MOSPermissionRequestDialogChoice */, userResponse, 'Click', 'MOSPermissionRequestDialog', appId);
    }, [appId]);
    return {
        permissionRequested,
        showConsentDialogCallback,
        closeConsentDialogCallback,
    };
}
//# sourceMappingURL=useConsentRequest.js.map